import { MediaMetadata } from './media-metadata';

export class Metadata {
    constructor(
        public metadata: MediaMetadata,
        public images: any[]) {
    }
}